import { useState } from 'react';
import { toast } from 'react-toastify';
import { exportQuotePdf } from '../api/quotesApi';

// Two entrypoints:
//   download(id, quoteNumber)  — fetches the blob, forces an anchor-click
//                                download, revokes the URL immediately.
//   getBlobUrl(id)             — returns { url, revoke } for the preview
//                                modal's <iframe src>. The modal must call
//                                `revoke()` on close to avoid a blob-URL
//                                leak (visible in devtools memory tab).
//
// We can't point the iframe at /ExportPdf/{id} directly because the Clerk
// bearer token lives in apiFetch — iframes can't inject Authorization headers.
export default function useExportQuotePdf() {
    const [isDownloading, setIsDownloading] = useState(false);

    const download = async (id, quoteNumber) => {
        setIsDownloading(true);
        try {
            const blob = await exportQuotePdf(id);
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `quote-${quoteNumber ?? id}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (err) {
            toast.error(err?.message ?? 'Failed to export quote');
        } finally {
            setIsDownloading(false);
        }
    };

    const getBlobUrl = async (id) => {
        const blob = await exportQuotePdf(id);
        const url = URL.createObjectURL(blob);
        return { url, revoke: () => URL.revokeObjectURL(url) };
    };

    return { download, getBlobUrl, isDownloading };
}
